import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "@/components/feature/ScrollToTop";
import SeoManager from "@/components/feature/SeoManager";
import JsonLd from "@/components/feature/JsonLd";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <SeoManager />
        <JsonLd />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;